.ci{border:1px solid #ddd;}